// extracted by mini-css-extract-plugin
module.exports = {"image_title":"ManageLearningLabs_image_title__35yJ_","add_image_container":"ManageLearningLabs_add_image_container__LPvku"};